import React from 'react'

const FgItemsReport = ({ resPacket }) => {
    return (
        <div className="customTable" id="scroll">
            <table className="customTable w-100">
                <thead className="fixed-thead">
                    <tr>
                        <td>Item Title</td>
                        <td>Unit Title</td>
                        <td>Quantity</td>
                    </tr>
                </thead>
                <tbody className="body-scroll-custom">
                    {
                        resPacket && resPacket?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>{item.itemTitle}</td>
                                    <td>{item.unitTitle}</td>
                                    <td>{item.quantity}</td>
                                </tr>
                            );
                        })
                    }
                </tbody>

            </table>
        </div>
    )
}

export default FgItemsReport